export default "__VITE_ASSET__b0184f85__"